module.exports = ".alert {\n    font-size: 15px;\n}\n.close span {\n    font-size: 25px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/alerts/alerts.component.css
// module id = ./src/app/_shared/alerts/alerts.component.css
// module chunks = main